import { useState } from 'react';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9qr8h4nlsngrm4lm4ig';

function BrandIntro() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
          品牌介绍
        </h2>
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">关于好博体育</h3>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                好博体育成立于2018年，是领先的专业体育竞技娱乐平台。我们汇聚全球顶级赛事资源，覆盖足球、篮球、网球、电竞、乒乓球、羽毛球等多项运动，为超过50万活跃用户提供实时数据、深度分析和专业预测服务。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                好博体育以"让每一位体育爱好者都能享受极致的赛事体验"为使命，持续投入技术研发和内容建设。我们的分析师团队由前职业运动员、资深体育记者和数据科学家组成，确保每一篇分析文章都兼具专业性和可读性。
              </p>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0 mt-0.5">
                  <i className="ri-eye-line text-primary-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">愿景</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">成为全球最受信赖的体育竞技平台</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 flex-shrink-0 mt-0.5">
                  <i className="ri-flag-line text-accent-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">使命</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">为全球体育爱好者提供专业、公正、便捷的赛事体验</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-50 flex-shrink-0 mt-0.5">
                  <i className="ri-heart-line text-secondary-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">价值观</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">安全第一、公正透明、用户至上、持续创新</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Reputation() {
  const certifications = [
    { icon: 'ri-shield-check-line', title: '安全认证', desc: '通过国际安全标准认证，数据加密传输，用户隐私保护达到最高等级' },
    { icon: 'ri-auction-line', title: '公平公正', desc: '独立审计机构定期审核，确保所有数据和分析结果的客观公正性' },
    { icon: 'ri-award-line', title: '行业认可', desc: '连续三年获得"最佳体育竞技平台"奖项，业内口碑卓越' },
    { icon: 'ri-user-heart-line', title: '用户信赖', desc: '98%用户好评率，50万+活跃用户的选择，口碑见证实力' },
  ];

  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
          信誉与资质
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
          {certifications.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 flex items-start gap-4"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 flex-shrink-0">
                <i className={`${item.icon} text-xl text-accent-500`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">平台数据</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="font-heading text-3xl font-bold text-primary-500">500K+</div>
              <div className="text-sm text-foreground-600 mt-1">注册用户</div>
            </div>
            <div>
              <div className="font-heading text-3xl font-bold text-primary-500">98%</div>
              <div className="text-sm text-foreground-600 mt-1">用户好评率</div>
            </div>
            <div>
              <div className="font-heading text-3xl font-bold text-primary-500">5K+</div>
              <div className="text-sm text-foreground-600 mt-1">分析文章</div>
            </div>
            <div>
              <div className="font-heading text-3xl font-bold text-primary-500">24/7</div>
              <div className="text-sm text-foreground-600 mt-1">客服支持</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactInfo() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formDataObj = new FormData(form);
    const honeypot = formDataObj.get('company_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      return;
    }

    if (formData.message.length > 500) {
      setFormError('留言内容不能超过500个字符');
      setFormStatus('error');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const response = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        }).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后重试');
          setFormStatus('error');
        } else {
          setFormError(serverMsg);
          setFormStatus('error');
        }
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
          联系我们
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="md:col-span-2 space-y-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">电子邮箱</h4>
                <p className="text-sm text-foreground-600">contact@haobo-sports.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 flex-shrink-0">
                <i className="ri-phone-line text-lg text-accent-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">客服热线</h4>
                <p className="text-sm text-foreground-600">400-888-9999</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-50 flex-shrink-0">
                <i className="ri-map-pin-line text-lg text-secondary-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">公司地址</h4>
                <p className="text-sm text-foreground-600">北京市朝阳区建国路88号好博大厦</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                <i className="ri-time-line text-lg text-primary-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">工作时间</h4>
                <p className="text-sm text-foreground-600">周一至周日 9:00 - 22:00</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            {formStatus === 'success' ? (
              <div className="bg-accent-50 border border-accent-200/70 rounded-xl p-8 text-center">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-100">
                  <i className="ri-check-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">消息已发送！</h3>
                <p className="text-sm text-foreground-600">感谢您的留言，我们将在24小时内回复您</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="bg-background-50 rounded-xl border border-background-200/70 p-6" data-readdy-form="">
                <div className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱地址"
                    />
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入咨询主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言内容
                      <span className="text-foreground-400 ml-1">({formData.message.length}/500)</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（不超过500字）"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="w-full py-3 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap"
                  >
                    {formStatus === 'loading' ? '提交中...' : '发送消息'}
                  </button>
                </div>
                {formStatus === 'error' && (
                  <p className="text-sm text-red-500 mt-3">{formError}</p>
                )}
                <div className="newsletter-honeypot">
                  <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于好博体育',
    description: '好博体育是领先的专业体育竞技娱乐平台，汇聚全球顶级赛事资源。了解好博体育的品牌故事、信誉资质和联系方式。',
    url: 'https://haobo-sports.com/about',
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 好博体育 | 品牌介绍、信誉资质与联系方式"
        description="好博体育是领先的专业体育竞技娱乐平台，汇聚全球顶级赛事资源。了解好博体育的品牌故事、信誉资质和联系方式，50万+用户的共同选择。"
        keywords="好博体育,好博体育官网,好博体育平台,好博体育关于我们,好博体育联系方式"
        canonicalUrl="https://haobo-sports.com/about"
        schemaJson={aboutSchema}
      />

      <div className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <div className="bg-background-100/70 py-10">
          <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              关于好博体育
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto leading-relaxed">
              领先的专业体育竞技娱乐平台，以安全、公正、便捷为核心，为广大体育爱好者打造极致的赛事体验
            </p>
          </div>
        </div>

        <BrandIntro />
        <Reputation />
        <ContactInfo />
      </div>
    </>
  );
}